<template>
  <div
    class="system-item"
    @click.stop="toggleSystem(system.id)">
    <i
      class="n-i n-i-circle"
      :class="{'n-i-check-a': active,
               'n-i-circle': !active}"/>
    <label :for="system.id">
      <span v-if="bankers"> {{ bankers }}B + </span>
      {{ system.id }}/{{ system.of }}
      <span class="system-combinations">
        ({{ system.combinations }})
      </span>
    </label>
  </div>
</template>
<script>
export default {
  name: 'SystemItem',
  props: {
    system: {
      required: true,
      type: Object,
    },
    bankers: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  computed: {
    active() {
      return this.system.active;
    },
  },
  methods: {
    toggleSystem(id) {
      this.$store.dispatch('toggleSystem', id);
    },
  },
};
</script>
